import React from 'react';
import SimplePageHeader from '@/header/SimplePageHeader';
import NotificationsTabs from '@/header/NotificationsTabs';

function NotificationsHeader({ active }) {
    return (
        <SimplePageHeader pageFixerClassName="tabs">
            <NotificationsTabs active={active} />
        </SimplePageHeader>
    );
}
export default NotificationsHeader;
